import { createContext, PropsWithChildren, useRef } from 'react'
import { createStore } from 'zustand'

import { WPMenu } from '@/types'

export type StoreProps = {
  strings?: Record<string, any>
  menu?: {
    header_menu: WPMenu
    main_menu_01: WPMenu
    main_menu_02: WPMenu
    main_menu_03: WPMenu
    main_menu_04: WPMenu
    footer_menu_01: WPMenu
    footer_menu_02: WPMenu
    footer_menu_03: WPMenu
    footer_menu_04: WPMenu
    legals_menu: WPMenu
    social_menu: WPMenu
  }
}

export type AppStore = ReturnType<typeof createAppStore>

const createAppStore = (initProps?: Partial<StoreProps>) => {
  return createStore<StoreProps>()(() => ({ ...initProps }))
}

export const StoreContext = createContext<AppStore | null>(null)

function StoreProvider({ children, ...props }: PropsWithChildren<StoreProps>) {
  const storeRef = useRef<AppStore>(null)

  if (!storeRef.current) {
    storeRef.current = createAppStore(props)
  }

  return <StoreContext.Provider value={storeRef.current}>{children}</StoreContext.Provider>
}

export default StoreProvider
